import { Box, Button, Dialog, Grid, IconButton, InputLabel, Typography } from '@mui/material';
import { ProceedSaveLater, SubHeading } from './components';
import {
  Formik,
  FormikErrors,
  FormikHelpers,
  setNestedObjectValues,
  validateYupSchema,
  yupToFormErrors,
} from 'formik';
import MFSelectField from '../../lib/formik/SelectField';
import UseRadioGroup from '../../lib/formik/Radio';
import { MFTextField } from '../../lib/formik';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CloseIcon from '@mui/icons-material/Close';
import { Applicant } from '../../redux-store/types/api-types';
import {
  addressTypesMasters,
  AMC_APPROVER_CHECK_FOR_INDIVIDUAL,
  basedOnBenefitPlanInvestor,
  fatcaDeclarations,
  genderMasters,
  IdTypeMasters,
  ReasonMaster,
  USER_ROLES,
  YesNoMaster,
} from '../../utils/constant';
import {
  USTaxableUSNonTaxableInvestorAccess,
  applicationComparison,
  applyRoleBasedStatus,
  getApplicantName,
  getArrayLength,
  isABenefitPlanInvestor,
  removeSingleQuote,
  saveForLater,
} from '../../utils/utilityFunctions';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { useHistory } from 'react-router';
import { updateApplication } from '../../redux-store/actions/application';
import { FATCAValidationSchema } from '../../utils/schema';
import { Notes } from './components';
import { useSnackbar } from 'notistack';
import { mdmsCountriesList, nationaliyType } from '../../redux-store/types/mdms';
import { getNationalityList } from '../../redux-store/actions';
import { SearchableSelect } from '../../lib/formik/searchSelectField';
import MFCheckbox from '../../lib/formik/Checkbox';
import { showError } from '../../redux-store/actions/auth';
import { GridItem } from './distributorDetails';
import { ConfirmationDialog, MFSelectVerient } from '../commonComponents';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

export type Values = {
  applicants: Partial<Applicant>[];
  saveType: string;
  countryDropdown: string[];
};
const TaxResidentCountryTin = { country: '', tin: '', sno: 0 };
const applicantObj = (setInitialValue: boolean) => {
  return {
    investorCategory: '',
    typeOfAddressProvidedAtKRA: '',
    placeOfBirth: '',
    countryOfBirth: '',
    fatcaDeclaration: true,
    taxResidentOfMultipleCountry: '',
    taxResidentCountryTin: [TaxResidentCountryTin],
    qualifiedClient: '',
    usTaxExemptLimitedPartner: '',
    isBenefitPlanInvestor: '',
    notABenefitPlanInvestor: false,
    isGovernmentPlan: false,
    isControlledPerson: false,
    aBenefitPlanInvestor: false,
    isSubjectToPart4: false,
    isSubjectToSection4975: false,
    isEntityWhoseUnderlying: false,
    entityAssetPercentage: '',
    isGroupTrust: false,
    // usPerson: '',
    // taxIdResidentOfAnyCountryOtherThanIndia: 'Yes',
    // countryOfNationality: '',
    // taxCountryName: '',
    // taxID: '',
    // idType: '',
    // nameOfEntity: '',
    // dateOfIncorporation: '',
    // cityOfIncorporation: '',
    // countryOfIncorporation: '',
    // entityExcemptionCode: '',
    // idTypeOthers: '',
    // tinNotAvailableReason: '',
    // othersTinNotAvailableReason: '',
  };
};

const initialValues: Values = {
  applicants: [
    {
      ...applicantObj(true),
      wishToUploadFatcaDocument: false,
    },
  ],
  saveType: 'save and proceed',
  countryDropdown: [],
};

export const TermsAndConditions = ({ onClose, open }: { onClose: any; open: any }): JSX.Element => {
  return (
    <>
      <Dialog
        onClose={onClose}
        open={open}
        sx={{
          '.MuiPaper-root ': {
            maxWidth: 800,
            p: { xs: 2, sm: '15px 5px 35px' },
            borderRadius: '10px',
            height: 'unset',
            overflowY: 'auto',
          },
        }}>
        <IconButton onClick={onClose} sx={{ alignSelf: 'flex-end' }}>
          <CloseIcon fontSize="medium" />
        </IconButton>
        <Box
          sx={{
            width: { xs: '100%', sm: '90%' },
            mx: 'auto',
            '.MuiTypography-root': {
              textAlign: 'start',
              fontFamily: 'Work Sans,sans-serif',
            },
          }}>
          <Typography sx={{ fontSize: 16, fontWeight: 400, pt: 1 }}>
            <Typography sx={{ fontSize: 16, fontWeight: 500 }} component="span">
              1.{' '}
            </Typography>
            Details under FATCA & CRS: The Central Board of Direct Taxes has notified Rules 114F to
            114H, as part of the Income-tax Rules, 1962, which Rules require Indian financial
            institutions such as the Bank to seek additional personal, tax and beneficial owner
            information and certain certifications and documentation from all our account holders.
            In relevant cases, information will have to be reported to tax authorities/ appointed
            agencies. Towards compliance, we may also be required to provide information to any
            institutions such as withholding agents for the purpose of ensuring appropriate
            withholding from the account or any proceeds in relation thereto. Should there be any
            change in any information provided by you,please ensure you advise us promptly, i.e.,
            within 30 days.
          </Typography>
          <Typography sx={{ fontSize: 16, fontWeight: 400, pt: 1 }}>
            <Typography sx={{ fontSize: 16, fontWeight: 500 }} component="span">
              2.{' '}
            </Typography>
            If you have any questions about your tax residency, please contact your tax advisor. If
            you are a US citizen or resident or green card holder, please include United States in
            the foreign country information field along with your US Tax Identification Number. It
            is mandatory to supply a TIN or functional equivalent if the country in which you are
            tax resident issues such identifiers. If no TIN is yet available or has not yet been
            issued, please provide an explanation and attach this to form
          </Typography>
        </Box>
      </Dialog>
    </>
  );
};

export const GuidelinesForFatca = ({ onClose, open }: { onClose: any; open: any }): JSX.Element => {
  return (
    <>
      <Dialog
        onClose={onClose}
        open={open}
        sx={{
          '.MuiPaper-root ': {
            maxWidth: 800,
            p: { xs: 2, sm: '15px 5px 35px' },
            borderRadius: '10px',
            height: 'unset',
            overflowY: 'auto',
          },
        }}>
        <IconButton onClick={onClose} sx={{ alignSelf: 'flex-end' }}>
          <CloseIcon fontSize="medium" />
        </IconButton>
        <Box
          sx={{
            width: { xs: '100%', sm: '90%' },
            mx: 'auto',
            '.MuiTypography-root': {
              textAlign: 'start',
              fontFamily: 'Work Sans,sans-serif',
            },
          }}>
          <Typography sx={{ fontSize: 16, fontWeight: 400, pt: 1 }}>
            <Typography sx={{ fontSize: 16, fontWeight: 500 }}>1. Who is US person?</Typography>
            In case of individuals, U.S. person means a citizen or Resident of the United States.
            Persons who would qualify as US person could be born in the United States, Born outside
            the united states of a US parents, Naturalized Citizens, Green Card Holders,Tax
            residents.
          </Typography>
          <Typography sx={{ fontSize: 16, fontWeight: 400, pt: 1 }}>
            <Typography sx={{ fontSize: 16, fontWeight: 500 }}>
              2. Who is a reportable person (non US) under common reporting standards (CRS)?{' '}
            </Typography>
            Under common reporting standards (CRS), Reportable person means tax resident of a
            reportable foreign jurisdiction other than US
          </Typography>

          <Typography sx={{ fontSize: 16, fontWeight: 400, pt: 1 }}>
            <Typography sx={{ fontSize: 16, fontWeight: 500 }}>
              {` 3. Document to be submitted if Customer's Country of birth is US but Declares that
              he/she is not a US person`}
            </Typography>
            <Typography>
              • Certificate of relinquishment of citizenship (loss of nationality certificate)
            </Typography>
            <Typography>
              • Self certification for stating reason for not having such a certificate despite
              relinquishing US citizenship
            </Typography>
            <Typography>
              • Self certification for stating reasons for not obtaining US citizenship at birth.
            </Typography>
          </Typography>

          <Typography sx={{ fontSize: 16, fontWeight: 400, pt: 1 }}>
            <Typography sx={{ fontSize: 16, fontWeight: 500 }}>
              4. Towards compliance with tax information sharing laws, such as FATCA, we would be
              required to seek additional personal, tax and
            </Typography>
            <Typography>
              • Beneficial owner information and certain certifications and documentation from our
              account holders. Such information may be sought either at the time of account opening
              or any time subsequently. In certain circumstances we may be obliged to share
              information on your account with relevant tax authorities. If you have any questions
              about your tax residency, please contact your tax advisor. Should there be any change
              in any information provided by you, please ensure you advise us promptly, i.e., within
              30 days. Towards compliance with such laws, we may also be required to provide
              information to any institutions such as withholding agents for the purpose of ensuring
              appropriate withholding from the account or any proceeds in relation thereto. As may
              be required by domestic or overseas regulators/ tax authorities, we may also be
              constrained to withhold and pay out any sums from your account or close or suspend
              your account(s).
            </Typography>
            <Typography>
              • If any controlling person of the entity is a citizen or resident or green card
              holder of outside India, please include all such foreign country information field
              along with the relevantTax Identification Number.
            </Typography>
            <Typography>
              • Also note that you may receive more than one request to provide this information, if
              you have multiple relationships with us or our group entities. Therefore it is
              important that you respond to our request, even if you believe that you have already
              provided this information earlier Please note that above information is provided only
              for quick reference to customers. You are requested to refer Rule 114F, 114G and 114H
              of Income-tax Rules, 1962 consult a legal/tax advisor for any clarification.
            </Typography>
          </Typography>
        </Box>
      </Dialog>
    </>
  );
};

const FatcaDetails = ({
  applicantName,
  index,
  values,
  nationalitiesMdmsResponse,
  setValues,
}: {
  applicantName: string;
  index: number;
  values: Values;
  nationalitiesMdmsResponse: mdmsCountriesList[];
  setValues: FormikHelpers<Values>['setValues'];
}): JSX.Element => {
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const isFieldDisabled = [USER_ROLES.POAAPPROVER].includes(role);
  const [removeTin, SetRemoveTin] = useState<null | number>(null);
  const AddTin = async () => {
    try {
      setValues({
        ...values,
        applicants: values?.applicants?.map((applicant, _index) => {
          return _index === index
            ? {
                ...applicant,
                taxResidentCountryTin: applicant?.taxResidentCountryTin
                  ?.concat(TaxResidentCountryTin)
                  ?.map((item, i) => {
                    return { ...item, sno: i };
                  }),
              }
            : applicant;
        }),
      });
      return;
    } catch (e) {
      console.error((e as Error).message);
    }
  };
  const RemoveTin = (sno: number) => {
    setValues({
      ...values,
      applicants: values?.applicants?.map((applicant, _index) => {
        return _index === index
          ? {
              ...applicant,
              taxResidentCountryTin: applicant?.taxResidentCountryTin
                ?.filter((item) => item.sno !== sno)
                ?.map((item, i) => {
                  return { ...item, sno: i };
                }),
            }
          : applicant;
      }),
    });
    return;
  };

  // const [open, setOpen] = useState(false);

  // const handleOpen = () => {
  //   setOpen(true);
  // };
  // const handleClose = () => {
  //   setOpen(false);
  // };

  return (
    <>
      <SubHeading>FATCA Details of {applicantName} Applicant</SubHeading>
      {/* <Grid item xs={12}>
        <MFCheckbox
          name={`applicants.${index}.wishToUploadFatcaDocument`}
          label={'Wish to upload FATCA-CRS Declaration'}
          sx={{ my: 2 }}
          disabled={isFieldDisabled}
        />
      </Grid> */}
      {!values?.applicants[index]?.wishToUploadFatcaDocument && (
        <>
          <Grid item xs={12} sm={6}>
            <MFSelectField
              name={`applicants.${index}.typeOfAddressProvidedAtKRA`}
              label="Type of Address provided *"
              items={addressTypesMasters.map((address) => ({ key: address, value: address }))}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`applicants.${index}.placeOfBirth`}
              label="Place of Birth *"
              placeholder="Enter Place of Birth"
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <UseRadioGroup
              formLabel={'Are you tax resident of multiple countries? *'}
              name={`applicants.${index}.taxResidentOfMultipleCountry`}
              items={Object.keys(YesNoMaster).map((item) => ({
                label: YesNoMaster[item],
                value: item,
              }))}
              onChange={({ target: { value } }) => {
                setValues({
                  ...values,
                  applicants: values?.applicants?.map((applicant, i) => {
                    if (index === i) {
                      return {
                        ...applicant,
                        taxResidentOfMultipleCountry: value,
                        ...(YesNoMaster[value] === YesNoMaster.no
                          ? {
                              taxResidentCountryTin: applicant?.taxResidentCountryTin?.filter(
                                (taxCountry) => taxCountry.sno === 0
                              ),
                            }
                          : {}),
                      };
                    }
                    return applicant;
                  }),
                });
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <MFSelectVerient
              name={`applicants.${index}.countryOfBirth`}
              label="Country of Birth *"
              items={nationalitiesMdmsResponse.map((nationality) => ({
                key: nationality.name,
                value: nationality.name,
              }))}
              disabled={isFieldDisabled}
              searchFieldPlaceholder={'Search Country'}
              searchSelectEnable={true}
            />
          </Grid>

          {values?.applicants[index]?.taxResidentCountryTin?.map((item, i) => (
            <Grid container rowSpacing={1} xs={12} sm={12} key={i}>
              <Grid item xs={12} sm={6}>
                <MFSelectVerient
                  name={`applicants.${index}.taxResidentCountryTin.${i}.country`}
                  label="Country of Tax Residency/TIN Issuing Country *"
                  items={nationalitiesMdmsResponse.map((nationality) => ({
                    key: nationality.name,
                    value: nationality.name,
                  }))}
                  disabled={i === 0}
                  searchFieldPlaceholder={'Search Country of Tax Residency/TIN Issuing Country'}
                  searchSelectEnable={true}
                />
              </Grid>
              <Grid item xs={12} sm={6} display={'flex'} direction={'row'}>
                <MFTextField
                  name={`applicants.${index}.taxResidentCountryTin.${i}.tin`}
                  label={`${i === 0 ? 'Primary ' : ''}TIN *`}
                  placeholder="Enter TIN"
                  disabled={i === 0}
                />
                {values?.applicants[index]?.taxResidentCountryTin?.length !== 1 && i !== 0 && (
                  <>
                    {i + 1 === values?.applicants[index]?.taxResidentCountryTin?.length && (
                      <AddIcon
                        onClick={AddTin}
                        sx={{ mt: 7, color: 'rgba(0,0,0,0.7)', ':hover': { cursor: 'pointer' } }}
                      />
                    )}

                    <RemoveIcon
                      onClick={() => SetRemoveTin(item.sno)}
                      sx={{ mt: 7, color: 'rgba(0,0,0,0.7)', ':hover': { cursor: 'pointer' } }}
                    />
                  </>
                )}
              </Grid>
            </Grid>
          ))}
          {values?.applicants[index]?.taxResidentCountryTin?.length === 1 &&
            YesNoMaster[values?.applicants[index]?.taxResidentOfMultipleCountry || ''] ===
              YesNoMaster.yes && (
              <Grid item xs={12}>
                <Button
                  variant="outlined"
                  startIcon={<AddIcon />}
                  sx={{
                    color: 'primary.main',
                    fontWeight: 500,
                    fontSize: 14,
                    mt: 2,
                  }}
                  onClick={AddTin}>
                  Add TIN
                </Button>
              </Grid>
            )}
          {/* <Grid item xs={12}>
            <UseRadioGroup
              formLabel="Tax Resident of any country *"
              name={`applicants.${index}.taxIdResidentOfAnyCountryOtherThanIndia`}
              items={[
                { label: 'Yes', value: 'Yes' },
                { label: 'No', value: 'No' },
              ]}
              disabled={isFieldDisabled}
            />
          </Grid> */}
          {/* {applicant?.taxIdResidentOfAnyCountryOtherThanIndia === 'Yes' && ( */}
          <>
            {/* <Grid item xs={12} sm={6}>
              <SearchableSelect
                name={`applicants.${index}.countryOfNationality`}
                label="Country of Citizenship/Nationality *"
                items={nationalitiesMdmsResponse.map((nationality) => ({
                  key: nationality.name,
                  value: nationality.name,
                }))}
                disabled={isFieldDisabled}
                searchFieldPlaceholder={'Search Country'}
              />
            </Grid> */}
            {/* {values?.taxIdResidentOfAnyCountryOtherThanIndia === 'Yes' && (
              <>
                <Grid item xs={12} sm={6}>
                  <SearchableSelect
                    name={`applicants.${index}.taxCountryName`}
                    label="Country of Tax Residency/TIN Issuing Country *"
                    items={nationalitiesMdmsResponse.map((nationality) => ({
                      key: nationality.name,
                      value: nationality.name,
                    }))}
                    disabled={isFieldDisabled}
                    searchFieldPlaceholder={'Search Country'}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFSelectField
                    name={`applicants.${index}.idType`}
                    label="ID Type *"
                    items={IdTypeMasters.map((_idType) => ({
                      key: _idType,
                      value: _idType,
                    }))}
                    disabled={isFieldDisabled}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.taxID`}
                    label="Tax Identification Number (TIN)/Equivalent Number *"
                    placeholder="Enter TIN/Equivalent Number"
                    disabled={isFieldDisabled}
                  />
                </Grid>
                {values.idType === 'OTHERS' && (
                  <>
                    <Grid item xs={12} sm={6}>
                      <MFTextField
                        name={`applicants.${index}.idTypeOthers`}
                        label="Please Specify ID Type *"
                        placeholder="Enter ID Type"
                        disabled={isFieldDisabled}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
                        <MFSelectField
                          name={`applicants.${index}.tinNotAvailableReason`}
                          label="Reason (If TIN is not available) *"
                          items={Object.keys(ReasonMaster).map((reason) => ({
                            key: ReasonMaster[reason].code,
                            value: reason,
                          }))}
                          disabled={isFieldDisabled}
                        />
                        <Typography component="span" ml={1} sx={{ cursor: 'pointer' }}>
                          <InfoOutlinedIcon color="info" fontSize="small" onClick={handleOpen} />
                        </Typography>
                      </Box>
                    </Grid>
                    {ReasonMaster[values.tinNotAvailableReason || '']?.code ===
                      ReasonMaster.reason_c.code && (
                      <Grid item xs={12} sm={6}>
                        <MFTextField
                          name={`applicants.${index}.othersTinNotAvailableReason`}
                          label="Please Specify Reason *"
                          placeholder="Enter Reason"
                          disabled={isFieldDisabled}
                        />
                      </Grid>
                    )}
                  </>
                )}
              </>
            )} */}
            {/* <Grid item xs={12} sm={6} sx={{ pt: '25px !important' }}>
              <UseRadioGroup
                formLabel="Are You a US Person *"
                name={`applicants.${index}.usPerson`}
                items={Object.keys(YesNoMaster).map((item) => ({
                  label: YesNoMaster[item],
                  value: item,
                }))}
                disabled={isFieldDisabled}
              />
            </Grid> */}
            {USTaxableUSNonTaxableInvestorAccess(
              values?.applicants[index]?.investorCategory || ''
            ) && (
              <>
                <Grid item xs={12} sm={12} sx={{ pt: '25px !important' }}>
                  <UseRadioGroup
                    formLabel="Are you a Qualified Client within the meaning of Rule 205-3 of the Advisors Act? *"
                    name={`applicants.${index}.qualifiedClient`}
                    items={Object.keys(YesNoMaster).map((item) => ({
                      label: YesNoMaster[item],
                      value: item,
                    }))}
                    disabled={isFieldDisabled}
                  />
                </Grid>
                <Grid item xs={12} sm={12} sx={{ pt: '25px !important' }}>
                  <UseRadioGroup
                    formLabel="Are you a US Tax-Exempt Limited Partner? *"
                    name={`applicants.${index}.usTaxExemptLimitedPartner`}
                    items={Object.keys(YesNoMaster).map((item) => ({
                      label: YesNoMaster[item],
                      value: item,
                    }))}
                    disabled={isFieldDisabled}
                  />
                </Grid>
                <Grid item xs={12} sm={12} sx={{ pt: '25px !important' }}>
                  <UseRadioGroup
                    formLabel="Are you a 'Benefit Plan Investor'? *"
                    name={`applicants.${index}.isBenefitPlanInvestor`}
                    items={Object.keys(YesNoMaster).map((item) => ({
                      label: YesNoMaster[item],
                      value: item,
                    }))}
                    disabled={isFieldDisabled}
                  />
                </Grid>
                {Object.keys(fatcaDeclarations).map(
                  (item, i) =>
                    (item === 'fatcaDeclaration' ||
                      (isABenefitPlanInvestor(
                        values?.applicants[index]?.isBenefitPlanInvestor || ''
                      ) &&
                        [
                          'aBenefitPlanInvestor',
                          'isSubjectToPart4',
                          'isSubjectToSection4975',
                          'isEntityWhoseUnderlying',
                          'isGroupTrust',
                        ].includes(item)) ||
                      (!isABenefitPlanInvestor(
                        values?.applicants[index]?.isBenefitPlanInvestor || ''
                      ) &&
                        [
                          'notABenefitPlanInvestor',
                          'isGovernmentPlan',
                          'isControlledPerson',
                        ].includes(item))) && (
                      <Grid
                        item
                        xs={12}
                        sx={{
                          mt: 2,
                          ...(basedOnBenefitPlanInvestor.includes(item) ? { ml: 4 } : {}),
                        }}
                        key={i}>
                        <MFCheckbox
                          name={`applicants.${index}.${item}`}
                          label={fatcaDeclarations[item]}
                          sx={{
                            color: 'rgba(0,0,0,0.7)',
                            textAlign: 'justify',
                            '.MuiTypography-root': {
                              fontSize: 15,
                              fontWeight: 500,
                            },
                            '& .MuiFormControlLabel-label.Mui-disabled': {
                              color: 'rgba(0,0,0,0.7) !important',
                            },
                          }}
                          disabled={
                            basedOnBenefitPlanInvestor.includes(item) &&
                            !values?.applicants[index]?.aBenefitPlanInvestor
                          }
                          onChange={({ target: { checked } }) =>
                            setValues({
                              ...values,
                              applicants: values?.applicants?.map((applicant, _index) => {
                                if (_index === index) {
                                  return {
                                    ...applicant,
                                    [item]: checked,
                                    ...(item === 'isEntityWhoseUnderlying' && checked === false
                                      ? { entityAssetPercentage: '' }
                                      : item === 'aBenefitPlanInvestor' && checked === false
                                      ? {
                                          entityAssetPercentage: '',
                                          isEntityWhoseUnderlying: false,
                                          isSubjectToSection4975: false,
                                          isSubjectToPart4: false,
                                          isGroupTrust: false,
                                        }
                                      : {}),
                                  };
                                } else {
                                  return applicant;
                                }
                              }),
                            })
                          }
                        />
                        {item === 'isEntityWhoseUnderlying' && (
                          <>
                            <Grid item xs={12} sm={6}>
                              <MFSelectVerient
                                name={`applicants.${index}.entityAssetPercentage`}
                                label=""
                                items={getArrayLength(10).map((item) => ({
                                  key: `${item * 10}%`,
                                  value: `${item * 10}%`,
                                }))}
                                disabled={
                                  basedOnBenefitPlanInvestor.includes(item) &&
                                  !values?.applicants[index]?.isEntityWhoseUnderlying
                                }
                              />
                            </Grid>
                            <Typography
                              sx={{
                                ml: 4,
                                mr: 3,
                                mt: 2,
                                fontSize: 15,
                                fontWeight: 500,
                                color: 'rgba(0,0,0,0.7)',
                                textAlign: 'justify',
                              }}>
                              (*applicable to entities with multiple classes, one of which exceeds
                              the 25% threshold for Benefit Plan Investors and to U.S. insurance
                              company general accounts)
                            </Typography>
                          </>
                        )}
                      </Grid>
                    )
                )}
              </>
            )}
            {/* <Grid item xs={12} sm={6}>
            <MFTextField
              name={`applicants.${index}.nameOfEntity`}
              label="Name of Entity"
              placeholder="Enter Name of Entity"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <DatePicker
              label="Date of Incorporation"
              inputLabelStyles={{
                transform: 'unset',
                fontSize: 14,
                fontWeight: 500,
                color: 'rgba(0,0,0,0.7)',
              }}
              maxDate={minDateForContributor()}
              name={`applicants.${index}.dateOfIncorporation`}
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              value={applicant.dateOfBirth || minDateForContributor().toString()}
              onChange={(newValue) => {
                setValues({
                  ...values,
                  applicants: values.applicants.map((applicant, ind) => {
                    if (index === ind) {
                      return {
                        ...applicant,
                        dateOfIncorporation: newValue?.toString(),
                      };
                    }
                    return applicant;
                  }),
                });
              }}
              textFieldStyles={{
                'label + &': {
                  mt: 4,
                },
                '& .MuiInputBase-root': {
                  border: '1px solid #DDEAF3',
                },
                '& .MuiOutlinedInput-root': {
                  position: 'relative',
                  backgroundColor: 'common.white',
                  border: '1px solid #DDEAF3',
                  fontSize: 16,
                  '&:hover': {
                    borderColor: 'primary.main',
                    '.MuiOutlinedInput-notchedOutline': {
                      border: 0,
                    },
                  },
                  '.MuiOutlinedInput-notchedOutline': {
                    border: 0,
                  },
                  '.MuiInputBase-input': {
                    p: '10px 12px',
                  },
                  '&:focus-visible': {
                    outline: 'none',
                  },
                },
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`applicants.${index}.cityOfIncorporation`}
              label="City of Incorporation"
              placeholder="Enter City of Incorporation"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`applicants.${index}.countryOfIncorporation`}
              label="Country of Incorporation"
              placeholder="Enter Country of Incorporation"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`applicants.${index}.entityExcemptionCode`}
              label="Entity Exemption Code"
              placeholder="Enter Entity Exemption Code"
            />
          </Grid> */}
          </>
          {/* )} */}
        </>
      )}
      <ConfirmationDialog
        message={`Are you sure you want to delete?`}
        open={removeTin !== null}
        setOpen={() => SetRemoveTin(null)}
        onSave={async () => {
          SetRemoveTin(null);
          RemoveTin(removeTin as number);
        }}
        onCancel={() => SetRemoveTin(null)}
      />
      {/* <Dialog
        onClose={handleClose}
        open={open}
        sx={{
          '.MuiPaper-root ': {
            maxWidth: 800,
            p: { xs: 2, sm: '15px 5px 35px' },
            borderRadius: '10px',
            height: 'unset',
            overflowY: 'auto',
          },
        }}>
        <IconButton onClick={handleClose} sx={{ alignSelf: 'flex-end' }}>
          <CloseIcon fontSize="medium" />
        </IconButton>
        <Box
          sx={{
            width: { xs: '100%', sm: '90%' },
            mx: 'auto',
            '.MuiTypography-root': {
              textAlign: 'start',
              fontFamily: 'Work Sans,sans-serif',
            },
          }}>
          <Typography sx={{ fontSize: 16, fontWeight: 400 }}>
            *If a TIN is unavailable, please provide the appropriate reason A, B or C as defined
            below:
          </Typography>
          <Typography sx={{ fontSize: 16, fontWeight: 400, pt: 1 }}>
            <Typography sx={{ fontSize: 16, fontWeight: 500 }} component="span">
              Reason A –{' '}
            </Typography>
            {ReasonMaster.reason_a.description}
          </Typography>
          <Typography sx={{ fontSize: 16, fontWeight: 400, pt: 1 }}>
            <Typography sx={{ fontSize: 16, fontWeight: 500 }} component="span">
              Reason B –{' '}
            </Typography>
            {ReasonMaster.reason_b.description}
          </Typography>
          <Typography sx={{ fontSize: 16, fontWeight: 400, pt: 1 }}>
            <Typography sx={{ fontSize: 16, fontWeight: 500 }} component="span">
              Reason C –{' '}
            </Typography>
            {ReasonMaster.reason_c.description}
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Button
              variant="contained"
              sx={{ minWidth: { xs: '170px', sm: '220px' }, mt: 3 }}
              onClick={handleClose}>
              Done
            </Button>
          </Box>
        </Box>
      </Dialog> */}
    </>
  );
};

export default function Fatca(): JSX.Element {
  const [fatcaDetails, setFatcaDetails] = useState(initialValues);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [openGuidelines, setOpenGuidelines] = useState(false);
  const { application } = useSelector((store: RootStateType) => store.application);
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const dispatch = useDispatch();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const [mdmsCountriesList, setMdmsCountriesList] = useState<mdmsCountriesList[]>([]);
  const [primaryTaxResidentCountryTin, setPrimaryTaxResidentCountryTin] = useState<
    {
      country: string;
      tin: string;
      applicant_type?: string;
    }[]
  >([
    {
      country: '',
      tin: '',
      applicant_type: '1',
    },
  ]);
  // useEffect(() => {
  //   (async function () {
  //     try {
  //       const nationalitiesMdmsMasters = (await dispatch(
  //         getNationalityList()
  //       )) as unknown as nationaliyType;
  //       setMdmsCountriesList(nationalitiesMdmsMasters.countries);
  //     } catch (e) {
  //       console.error((e as Error).message);
  //     }
  //   })();
  // }, []);

  useEffect(() => {
    const { applicants = [] } = application || {};
    (async function () {
      try {
        const nationalitiesMdmsMasters = (await dispatch(
          getNationalityList()
        )) as unknown as nationaliyType;
        setMdmsCountriesList(nationalitiesMdmsMasters.countries);
        const PrimaryTaxResidentCountryTin = applicants.map((applicant) => ({
          applicant_type: applicant.applicant_type,
          country:
            nationalitiesMdmsMasters.countries.find(
              (item) => item.nationality === applicant.nationality
            )?.name || '',
          tin: applicant.taxIdNumber || '',
        }));
        setPrimaryTaxResidentCountryTin(PrimaryTaxResidentCountryTin);
        setFatcaDetails({
          ...fatcaDetails,
          applicants: applicants?.map((applicant) => ({
            investorCategory: applicant.investorCategory || '',
            typeOfAddressProvidedAtKRA: applicant.typeOfAddressProvidedAtKRA || '',
            placeOfBirth: applicant.placeOfBirth || '',
            countryOfBirth:
              applicant.countryOfBirth ||
              nationalitiesMdmsMasters.countries.find(
                (item) => item.nationality === applicant.nationality
              )?.name ||
              '',
            taxResidentOfMultipleCountry: applicant.taxResidentOfMultipleCountry || '',
            taxResidentCountryTin: (applicant.taxResidentCountryTin?.length
              ? applicant.taxResidentCountryTin.map((TaxResidentCountry) => {
                  if (TaxResidentCountry.sno.toString() === '0') {
                    return {
                      ...TaxResidentCountry,
                      tin: applicant.taxIdNumber || '',
                      country:
                        nationalitiesMdmsMasters.countries.find(
                          (item) => item.nationality === applicant.nationality
                        )?.name || '',
                    };
                  }
                  return TaxResidentCountry;
                })
              : PrimaryTaxResidentCountryTin.filter(
                  (_applicant) => applicant.applicant_type === _applicant.applicant_type
                ).map((_applicant) => ({ country: _applicant.country, tin: _applicant.tin }))
            ).map((item, ind) => {
              return { ...item, sno: ind };
            }),
            qualifiedClient: applicant.qualifiedClient || '',
            usTaxExemptLimitedPartner: applicant.usTaxExemptLimitedPartner || '',
            isBenefitPlanInvestor: applicant.isBenefitPlanInvestor || '',
            notABenefitPlanInvestor: applicant.notABenefitPlanInvestor || false,
            isGovernmentPlan: applicant.isGovernmentPlan || false,
            isControlledPerson: applicant.isControlledPerson || false,
            aBenefitPlanInvestor: applicant.aBenefitPlanInvestor || true,
            isSubjectToPart4: applicant.isSubjectToPart4 || false,
            isSubjectToSection4975: applicant.isSubjectToSection4975 || false,
            isEntityWhoseUnderlying: applicant.isEntityWhoseUnderlying || false,
            entityAssetPercentage: applicant.entityAssetPercentage || '',
            isGroupTrust: applicant.isGroupTrust || false,
            fatcaDeclaration: applicant.fatcaDeclaration || true,
            wishToUploadFatcaDocument:
              applicant.wishToUploadFatcaDocument === null
                ? false
                : applicant.wishToUploadFatcaDocument,
            // usPerson: applicant.usPerson || '',
            // taxIdResidentOfAnyCountryOtherThanIndia:
            //   applicant.taxIdResidentOfAnyCountryOtherThanIndia || 'Yes',
            // countryOfNationality: applicant.countryOfNationality || applicant.nationality || '',
            // taxCountryName: applicant.taxCountryName || '',
            // taxID: applicant.taxID || applicant.taxIdNumber || '',
            // idType: applicant.idType || 'TIN' || '',
            // nameOfEntity: applicant.nameOfEntity || '',
            // dateOfIncorporation: applicant.dateOfIncorporation || '',
            // cityOfIncorporation: applicant.cityOfIncorporation || '',
            // countryOfIncorporation: applicant.countryOfIncorporation || '',
            // entityExcemptionCode: applicant.entityExcemptionCode || '',
            // idTypeOthers: applicant.idTypeOthers || '',
            // tinNotAvailableReason: applicant.tinNotAvailableReason || '',
            // othersTinNotAvailableReason: applicant.othersTinNotAvailableReason || '',
          })),
          countryDropdown: nationalitiesMdmsMasters.countries.map((list) => list.name),
        });
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, [application]);

  const handleOpenGuideline = () => {
    setOpenGuidelines(true);
  };
  const handleCloseGuideline = () => {
    setOpenGuidelines(false);
  };

  const handleOpenTermsAndConditions = () => {
    setOpen(true);
  };
  const handleCloseTermsAndConditions = () => {
    setOpen(false);
  };

  const handleSubmit = async (values: Values) => {
    try {
      const {
        applicants: existingApplicants = [],
        id,
        applicant1ReferenceId = '',
        currentStep,
        status,
        hasPOA,
        applicationNumber,
      } = application || {};
      const { applicants, saveType } = values;
      const updatedPayload = existingApplicants.map((applicant, index: number) => {
        if (!applicants[index].wishToUploadFatcaDocument) {
          if (!applicants[index].fatcaDeclaration) {
            throw `Declaration of ${getApplicantName(index + 1)} Applicant is required`;
          }
          if (isABenefitPlanInvestor(applicants[index].isBenefitPlanInvestor || '')) {
            if (![applicants[index].aBenefitPlanInvestor].includes(true)) {
              throw `Please select the option under Benefit Plan Investor for ${getApplicantName(
                index + 1
              )} Applicant`;
            }
            if (
              applicants[index].aBenefitPlanInvestor &&
              ![
                applicants[index].isEntityWhoseUnderlying,
                applicants[index].isSubjectToSection4975,
                applicants[index].isSubjectToPart4,
                applicants[index].isGroupTrust,
              ].includes(true)
            ) {
              throw `Please select Declaration of ${getApplicantName(
                index + 1
              )} Applicant (i),(ii),(iii) & (iv)`;
            }
          } else {
            if (
              USTaxableUSNonTaxableInvestorAccess(
                values?.applicants[index]?.investorCategory || ''
              ) &&
              ![
                applicants[index].notABenefitPlanInvestor,
                applicants[index].isGovernmentPlan,
                applicants[index].isControlledPerson,
              ].includes(true)
            ) {
              throw `Please select any one option under Benefit Plan Investor for ${getApplicantName(
                index + 1
              )} Applicant`;
            }
          }
        }
        const {
          // dateOfBirth = '',
          dateOfIncorporation = '',
          ...rest
        } = applicants[index];

        if (applicants[index].wishToUploadFatcaDocument) {
          return {
            ...applicant,
            ...applicantObj(true),
            investorCategory: applicant.investorCategory,
            taxResidentCountryTin: primaryTaxResidentCountryTin
              .filter(
                (_applicant) => _applicant.applicant_type === applicants[index].applicant_type
              )
              .map((_applicant, i) => ({
                country: _applicant.country,
                tin: _applicant.tin,
                sno: i,
              })),
            wishToUploadFatcaDocument: applicants[index].wishToUploadFatcaDocument,
          };
        } else {
          return {
            ...applicant,
            ...rest,
            investorCategory: applicant.investorCategory,
            placeOfBirth: removeSingleQuote(rest.placeOfBirth),
            taxResidentCountryTin: (applicants[index]?.taxResidentCountryTin?.length
              ? applicants[index]?.taxResidentCountryTin
              : primaryTaxResidentCountryTin.filter(
                  (_applicant) => _applicant.applicant_type === applicant.applicant_type
                )
            )?.map((_applicant, i) => ({
              country: _applicant.country,
              tin: _applicant.tin,
              sno: i,
            })),
            wishToUploadFatcaDocument: applicants[index].wishToUploadFatcaDocument,
            notABenefitPlanInvestor: isABenefitPlanInvestor(
              applicants[index].isBenefitPlanInvestor || ''
            )
              ? false
              : applicants[index].notABenefitPlanInvestor,
            isGovernmentPlan: isABenefitPlanInvestor(applicants[index].isBenefitPlanInvestor || '')
              ? false
              : applicants[index].isGovernmentPlan,
            isControlledPerson: isABenefitPlanInvestor(
              applicants[index].isBenefitPlanInvestor || ''
            )
              ? false
              : applicants[index].isControlledPerson,
            aBenefitPlanInvestor: !isABenefitPlanInvestor(
              applicants[index].isBenefitPlanInvestor || ''
            )
              ? false
              : applicants[index].aBenefitPlanInvestor,
            isSubjectToPart4: !isABenefitPlanInvestor(applicants[index].isBenefitPlanInvestor || '')
              ? false
              : applicants[index].isSubjectToPart4,
            isSubjectToSection4975: !isABenefitPlanInvestor(
              applicants[index].isBenefitPlanInvestor || ''
            )
              ? false
              : applicants[index].isSubjectToSection4975,
            isEntityWhoseUnderlying: !isABenefitPlanInvestor(
              applicants[index].isBenefitPlanInvestor || ''
            )
              ? false
              : applicants[index].isEntityWhoseUnderlying,
            entityAssetPercentage: !isABenefitPlanInvestor(
              applicants[index].isBenefitPlanInvestor || ''
            )
              ? ''
              : applicants[index].entityAssetPercentage,
            isGroupTrust: !isABenefitPlanInvestor(applicants[index].isBenefitPlanInvestor || '')
              ? false
              : applicants[index].isGroupTrust,
            // taxCountryName:
            //   rest.taxIdResidentOfAnyCountryOtherThanIndia === 'Yes' ? rest.taxCountryName : '',
            // taxID: rest.taxIdResidentOfAnyCountryOtherThanIndia === 'Yes' ? rest.taxID : '',
            // idType: rest.taxIdResidentOfAnyCountryOtherThanIndia === 'Yes' ? rest.idType : '',
            // idTypeOthers:
            //   rest.taxIdResidentOfAnyCountryOtherThanIndia === 'Yes' && rest.idType === 'OTHERS'
            //     ? removeSingleQuote(rest.idTypeOthers)
            //     : '',
            // tinNotAvailableReason:
            //   rest.taxIdResidentOfAnyCountryOtherThanIndia === 'Yes' && rest.idType === 'OTHERS'
            //     ? rest.tinNotAvailableReason
            //     : '',
            // othersTinNotAvailableReason:
            //   rest.taxIdResidentOfAnyCountryOtherThanIndia === 'Yes' &&
            //   ReasonMaster[rest.tinNotAvailableReason || '']?.code === ReasonMaster.reason_c.code
            //     ? removeSingleQuote(rest.othersTinNotAvailableReason)
            //     : '',
          };
        }
      });
      const checkApplication = applicationComparison(application, {
        ...application,
        applicants: updatedPayload,
        currentStep: !!currentStep && currentStep > 4 ? currentStep : Number(currentStep) + 1,
      });
      const isSaveLater = saveType !== 'save and proceed';
      if (id && !checkApplication) {
        setLoading(true);
        await dispatch(
          updateApplication({
            body: {
              ...application,
              applicants: updatedPayload,
              status:
                !hasPOA &&
                AMC_APPROVER_CHECK_FOR_INDIVIDUAL &&
                status !== 'draft' &&
                applyRoleBasedStatus(role)
                  ? 'sent_to_amc_approver'
                  : status,
              currentStep: 5,
              //!!currentStep && currentStep > 4 ? currentStep : Number(currentStep) + 1,
            },
            applicationId: id,
            ...(isSaveLater && { toastMessage: '' }),
          })
        );
      } else if (checkApplication) {
        if (isSaveLater) {
          enqueueSnackbar(`Application ${applicationNumber} - ` + ' Saved successfully', {
            variant: 'success',
            autoHideDuration: 3000,
          });
        }
      }

      const routeToSaveForLater = isSaveLater && saveForLater(role, id, applicant1ReferenceId);
      !isSaveLater
        ? history.push('nominee-details', { id, applicant1ReferenceId })
        : routeToSaveForLater && history.push(routeToSaveForLater);
    } catch (e) {
      typeof e === 'string' && dispatch(showError(e));
      console.error((e as Error).message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Formik
      initialValues={fatcaDetails}
      onSubmit={handleSubmit}
      validate={(values: Values) => {
        try {
          validateYupSchema(values, FATCAValidationSchema(mdmsCountriesList), true, values);
        } catch (e) {
          return yupToFormErrors(e);
        }
      }}
      enableReinitialize={true}>
      {({
        handleSubmit,
        values,
        setValues,
        setErrors,
        setTouched,
        validateForm,
        setFieldError,
        setFieldTouched,
      }) => (
        <Grid
          container
          rowSpacing={1}
          // columnSpacing={5}
          sx={{
            width: '100%',
            ml: 0,
            '.MuiGrid-item': { px: { xs: 0, sm: '30px' } },
          }}
          component="form"
          noValidate
          onSubmit={handleSubmit}>
          <GridItem>
            <Typography component="div" sx={{ display: 'flex' }}>
              <InputLabel
                shrink
                sx={{
                  transform: 'unset',
                  fontSize: 14,
                  fontWeight: 500,
                  color: 'rgba(0,0,0,0.7)',
                  mr: 1,
                }}>
                {'Terms and conditions'}
              </InputLabel>
              <InfoOutlinedIcon
                color="info"
                fontSize="small"
                onClick={handleOpenTermsAndConditions}
                sx={{ cursor: 'pointer' }}
              />
            </Typography>
            <Typography component="div" sx={{ display: 'flex' }}>
              <InputLabel
                shrink
                sx={{
                  transform: 'unset',
                  fontSize: 14,
                  fontWeight: 500,
                  color: 'rgba(0,0,0,0.7)',
                  mt: 1,

                  justifyContent: 'center',
                  display: 'flex',
                  alignItems: 'center',
                }}>
                {'Guidelines'}
                <InfoOutlinedIcon
                  color="info"
                  fontSize="small"
                  sx={{ ml: 1, cursor: 'pointer' }}
                  onClick={handleOpenGuideline}
                />
              </InputLabel>
            </Typography>
          </GridItem>
          <TermsAndConditions onClose={handleCloseTermsAndConditions} open={open} />
          <GuidelinesForFatca onClose={handleCloseGuideline} open={openGuidelines} />
          {values?.applicants?.map((applicant, index) => (
            <FatcaDetails
              applicantName={getApplicantName(index + 1)}
              index={index}
              key={index}
              values={values}
              nationalitiesMdmsResponse={mdmsCountriesList}
              setValues={(val) => setValues(val)}
            />
          ))}
          <ProceedSaveLater
            saveLater={() => {
              setValues({
                ...values,
                saveType: 'save for later',
              });
            }}
            saveAndProceed={() => {
              setValues({
                ...values,
                saveType: 'save and proceed',
              });
            }}
            loader={loading}
            clickedButton={values.saveType}
          />
        </Grid>
      )}
    </Formik>
  );
}
